import type { ConsentSnapshot } from "./types";

export type ConsentEvidencePayload = {
  state: "granted" | "denied";
  gpc: boolean;
  dnt: boolean;
  cmp?: ConsentSnapshot["cmp"];
  signalSource: string;
};

export type ConsentEvidence = {
  fingerprint: string;
  payload: ConsentEvidencePayload;
};

export function resolveConsentSignalSource(
  snapshot: ConsentSnapshot,
  fallbackSource?: string,
): string | undefined {
  if (snapshot.gpc && snapshot.state === "denied") return "gpc";
  if (snapshot.dnt && snapshot.state === "denied") return "dnt";
  if (snapshot.cmp?.source) return snapshot.cmp.source;
  return fallbackSource;
}

export function buildConsentEvidence(
  snapshot: ConsentSnapshot,
  fallbackSource?: string,
): ConsentEvidence | null {
  if (snapshot.state !== "granted" && snapshot.state !== "denied") {
    return null;
  }

  const signalSource = resolveConsentSignalSource(snapshot, fallbackSource);
  if (!signalSource) return null;

  const payload: ConsentEvidencePayload = {
    state: snapshot.state,
    gpc: snapshot.gpc,
    dnt: snapshot.dnt,
    cmp: snapshot.cmp,
    signalSource,
  };

  return {
    fingerprint: JSON.stringify({
      state: snapshot.state,
      signalSource,
      gpc: snapshot.gpc,
      dnt: snapshot.dnt,
      cmpSource: snapshot.cmp?.source,
      tcString: snapshot.cmp?.tcString,
      uspString: snapshot.cmp?.uspString,
      gppString: snapshot.cmp?.gppString,
      gppSectionIds: snapshot.cmp?.gppSectionIds,
    }),
    payload,
  };
}
